import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import type { ClassificationTypeFindInterface } from '@zaoblako/shared/modules/finance/dtos/classification/classification-type-find.dto';

import * as yup from 'yup';

/** Classification category response body - DTO signature */
export interface ClassificationCategoryFindInterface {
  /** Unique identifier */
  id: number;

  // Tech columns
  /** Classification category creation date and time */
  created: Date;
  /** Classification category last update date and time */
  updated: Date;
  /** Classification category soft deletion date and time */
  deleted?: Date;
  /** The user who created this classification category */
  createdBy?: UserFindInterface;

  // Data columns
  /** Classification category display name */
  name: string;
  /**
   * Can user edit this classification category?
   *
   * This flag for predefined embedded classification categories.
   */
  editable?: boolean;
  /** The classification type this classification category belongs to */
  type?: ClassificationTypeFindInterface;
}

/** Classification category response body - DTO schema */
export const ClassificationCategoryFindDto = SerdeDtoClass.create<ClassificationCategoryFindInterface>(
  FinanceDtoKeysEnum.CLASSIFICATION_CATEGORY_FIND_DTO,
  {
    id: {
      sortable: true,
      label: 'Номер',
      serializer: yup.number(),
    },
    created: {
      sortable: true,
      label: 'Создан',
      serializer: yup.date(),
    },
    updated: {
      sortable: true,
      label: 'Изменен',
      serializer: yup.date(),
    },
    deleted: {
      optional: true,
      label: 'Изменен',
      serializer: yup.date(),
    },
    createdBy: {
      optional: true,
      label: 'Автор',
      nested: UserFindDto,
      serializer: (_, nested) => nested,
    },
    name: {
      sortable: true,
      label: 'Название',
      serializer: yup.string(),
    },
    editable: {
      optional: true,
      label: 'Редактируемый',
      serializer: yup.boolean(),
    },
    type: {
      optional: true,
      label: 'Классификатор',
      nested: FinanceDtoKeysEnum.CLASSIFICATION_TYPE_FIND_DTO,
      serializer: (_, nested) => nested,
    },
  },
);
